import { AnalyticsBrowser } from '@segment/analytics-next'

let analytics: ReturnType<typeof AnalyticsBrowser.load> | null = null

const getCookie = (name: string): string | undefined => {
  const prefix = `${name}=`
  const row = document.cookie.split('; ').find((r) => r.startsWith(prefix))
  if (!row) return undefined
  const raw = row.slice(prefix.length)
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

export const trackWithSegments = (): boolean => {
  if (typeof window === 'undefined') return false
  if (getCookie('admin') !== undefined) return false
  return Boolean(process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY)
}

export const getSegmentAnalytics = () => {
  if (!trackWithSegments()) return null

  if (!analytics) {
    analytics = AnalyticsBrowser.load({
      writeKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY as string,
    })
  }

  return analytics
}

export const trackSegmentEvent = (eventName: string, properties?: Record<string, unknown>) => {
  const client = getSegmentAnalytics()
  if (!client) return

  void client.track(eventName, properties)
}
